import { apiInterfaceForJson } from "../common/apiManager";

export const fetchTemplates = () => {
    return apiInterfaceForJson("/template/v1/", "GET");
};

export const createTemplate = (templateData) => {
    return apiInterfaceForJson("/template/v1/", "POST", templateData);
};

export const updateTemplate = (templateData) => {
    return apiInterfaceForJson("/template/v1/", "PUT", templateData);
};

export const deleteTemplate = (templateId) => {
    return apiInterfaceForJson("/template/v1/delete", "POST", { _id: templateId });
};
